import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import { Link } from 'react-router-dom';

import IconButton from '@mui/material/IconButton'
import Tooltip from '@mui/material/Tooltip'
import Typography from '@mui/material/Typography';

import HeadsetMicOutlinedIcon from '@mui/icons-material/HeadsetMicOutlined'
import KeyboardArrowDownOutlinedIcon from '@mui/icons-material/KeyboardArrowDownOutlined';

import AvatarWithFallback from 'cityads-v3/components/ImgWithFallback/AvatarWithFallback'
import Manager from 'cityads-v3/containers/webmaster/profile/Manager';
import SupportButton from 'cityads-v3/components/Buttons/SupportButton';

import {
  USER_ROLE_CODE_WEBMASTER,
} from 'cityads-v3/reducers/auth';

import classes from './HeaderToolbar.scss';
import ButtonWithPopover from './ButtonWithPopover'
import { RootState } from 'cityads-v3/types/reducer';

export default function HeaderManager() {
  const { t } = useTranslation(['main'])
  const user = useSelector((state: RootState) => state.auth.user)
  const manager = useSelector((state: RootState) => state.header.manager)
  const isMobile = useSelector((state: RootState) => state.app.isMobile)

  if (!user || user.user_role_code !== USER_ROLE_CODE_WEBMASTER) {
    return null;
  }

  if (!manager) {
    return (
      <Tooltip title={t('header.helpdesk')}>
        <IconButton
          component={SupportButton}
          size="large"
        >
          <HeadsetMicOutlinedIcon className={classes.headerIcon} />
        </IconButton>
      </Tooltip>
    );
  }

  if (isMobile) {
    return (
      <Tooltip title={t('header.myManager')}>
        <IconButton component={Link} to={'/publisher/profile/manager'} classes={{ root: classes.avatarButton }} size="large">
          <AvatarWithFallback
            className={classes.managerAvatar}
            src={manager.avatar}
            fallbackSrc={require('./img/noavatar.png')}
          />
        </IconButton>
      </Tooltip>
    );
  }

  return (
    <>
      <ButtonWithPopover
        popoverContent={<Manager />}
      >
        <AvatarWithFallback
          className={classNames(classes.managerAvatar, classes.dropdownIcon)}
          src={manager.avatar}
          fallbackSrc={require('./img/noavatar.png')}
        />
        <Typography
          className={classes.dropdownItemText}
          color="textPrimary"
          variant="caption"
        >
          {t('header.myManager')}
        </Typography>
        <KeyboardArrowDownOutlinedIcon className={classes.arrowDown} />
      </ButtonWithPopover>
    </>
  );
}
